import React, { useState, useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import { clearAuthSession, setUsername } from '../../redux/slices/Auth/login'
import { show as showDrawerRight } from '../../redux/slices/Drawer/drawerRight'
import { show as showDrawerLeft } from '../../redux/slices/Drawer/drawerLeft'
import { invalidateMapData } from '../../redux/slices/Tree/treeFeatures'
import * as rdx from '../../redux/slices/Search/input'
import { useTheme } from '@mui/material/styles'
import { Logout } from '@mui/icons-material'
import { getUserById } from '../../services'
import { clearSavedViewport } from '../../utils/mapViewport'
import * as RT from '../../config/routes'
import _ from 'lodash'

import {
  Avatar,
  Box,
  Menu,
  MenuItem,
  ListItemIcon,
  Divider,
  IconButton,
  Tooltip,
  ListItemText,
} from '@mui/material'

const styleAvatar = {
  width: 26,
  height: 26,
  background: '#BBDEFB',
  color: '#2196F3',
}

const AccountMenu = ({ user, windowWidth }) => {
  const dispatch = useDispatch()
  let navigate = useNavigate()
  const theme = useTheme()

  const [anchorEl, setAnchorEl] = useState(null)

  const username = useSelector(state => state.login.username)

  const open = Boolean(anchorEl)

  const handleClick = event => {
    setAnchorEl(event.currentTarget)
  }

  const handleClose = () => {
    setAnchorEl(null)
  }

  const handleLogout = () => {
    window.sessionStorage.removeItem('ArbolEc_selectedTenant')
    clearSavedViewport()
    dispatch(rdx.basicListInitial())
    dispatch(rdx.filterListInitial())
    dispatch(rdx.setEnabledFilter(false))
    dispatch(clearAuthSession())
    dispatch(invalidateMapData())
    dispatch(setUsername(null))
    dispatch(showDrawerLeft(false))
    dispatch(showDrawerRight(false))
    navigate(RT.MAIN, { replace: true })
  }

  const handleProfile = () => {
    dispatch(showDrawerRight(false))
    dispatch(showDrawerLeft(false))
    navigate(RT.PROFILE_ROUTE)
  }

  useEffect(() => {
    if (username) return
    const tokenLocal = window.localStorage.getItem('ArbolEc_token')
    getUserById(user.id, `Bearer ${tokenLocal}`)
      .then(res => {
        const user = res.user
        let username = `${user?.nombre} ${user?.apellido}`
        username =
          username.length > 18 ? `${user?.nombre[0]} ${user?.apellido}` : username
        dispatch(setUsername(username))
      })
      .catch(err => {
        console.error('Error: ', err)
        dispatch(setUsername(_.capitalize(user?.rol?.[0])))
      })
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <>
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          textAlign: 'end',
          color: theme.palette.text.white,
        }}>
        {windowWidth >= 670 ? (
          <ListItemText
            primary={username ?? _.capitalize(user.rol[0])}
            secondary={username && _.capitalize(user.rol[0])}
            primaryTypographyProps={{
              fontFamily: theme.typography.fontFamily,
              fontSize: '0.8em',
              fontWeight: 600,
              lineHeight: '1.5em',
              color: theme.palette.text.white,
            }}
            secondaryTypographyProps={{
              fontFamily: theme.typography.fontFamily,
              fontSize: '0.8em',
              fontWeight: 700,
              lineHeight: '1em',
              color: theme.palette.text.secondary,
            }}
            sx={{ display: 'block', pl: 2 }}
          />
        ) : null}
        <Tooltip title="Configuración de cuenta">
          <IconButton
            onClick={handleClick}
            size="small"
            sx={{ ml: 2 }}
            aria-controls={open ? 'account-menu' : undefined}
            aria-haspopup="true"
            aria-expanded={open ? 'true' : undefined}>
            <Avatar sx={styleAvatar}>
              {username?.[0] ?? _.capitalize(user.rol[0][0])}
            </Avatar>
          </IconButton>
        </Tooltip>
      </Box>
      <Menu
        anchorEl={anchorEl}
        id="account-menu"
        open={open}
        onClose={handleClose}
        onClick={handleClose}
        PaperProps={{
          elevation: 0,
          sx: {
            overflow: 'visible',
            filter: 'drop-shadow(0px 2px 8px rgba(0,0,0,0.32))',
            mt: 1.5,
            '& .MuiAvatar-root': {
              width: 32,
              height: 32,
              ml: -0.5,
              mr: 1,
            },
            '&:before': {
              content: '""',
              display: 'block',
              position: 'absolute',
              top: 0,
              right: 14,
              width: 10,
              height: 10,
              bgcolor: 'background.paper',
              transform: 'translateY(-50%) rotate(45deg)',
              zIndex: 0,
            },
          },
        }}
        transformOrigin={{ horizontal: 'right', vertical: 'top' }}
        anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}>
        <MenuItem onClick={handleProfile}>
          <Avatar sx={styleAvatar} /> Mi cuenta
        </MenuItem>
        <Divider />
        <MenuItem onClick={handleLogout}>
          <ListItemIcon>
            <Logout fontSize="small" />
          </ListItemIcon>
          Cerrar Sesión
        </MenuItem>
      </Menu>
    </>
  )
}

export default AccountMenu
